import { useRef, useState } from "react";
import SearchField from "../components/SeachField";
import { decryptData, defaulUrl, fmt, listeMois } from "../components/const";
import { PrintFromApi } from "../components/PrintFromApi";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const RapportSalaire = () => {
    const currentDate = new Date();
    const [annee, setAnnee] = useState(currentDate.getFullYear());
    const [mois, setMois] = useState(currentDate.getMonth() + 1 < 10 ? `0${currentDate.getMonth() + 1}` : currentDate.getMonth() + 1);
    const [isLoading, setIsLoading] = useState(false);
    const [lesPayes, setLesPayes] = useState(null);

    const handleShowRapport = () => {
        let status = 0;
        setIsLoading(true);
        fetch(`${defaulUrl}salaire/${mois}/${annee}`, {
            method: "GET",
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            }
        }).then(response => {
            status = response.status;
            return response.json();
        }).then(data => {
            setIsLoading(false);
            if (status === 200) {
                setLesPayes(data);
            }
        });
    };

    const printbulletin = (pers) => {
        PrintFromApi(`bulletin/${pers.id}`, `bulletin_${pers.nom}_${pers.phone}_${pers.mois}_${pers.annee}`, setIsLoading);
    };

    const handlePrintSalaire = () => {
        if (!lesPayes?.length) return;

        const columns = [
            { header: "N°", dataKey: "index" },
            { header: "PRENOMS & NOM", dataKey: "nom" },
            { header: "TELEPHONE", dataKey: "phone" },
            { header: "SALAIRE", dataKey: "salaire" },
            { header: "PRIME", dataKey: "prime" },
            { header: "DESC. PRIME", dataKey: "desc_prime" },
            { header: "DETTE AVANT PAIE", dataKey: "dette" },
            { header: "DETTE REMBOURSE", dataKey: "remboursement" },
            { header: "RECU", dataKey: "salaire_net" },
            { header: "COMMENTAIRE", dataKey: "commentaire" },
            { header: "DATE", dataKey: "date" }
        ];

        const data = lesPayes.map((pers, ind) => ({
            index: ind + 1,
            nom: pers.nom?.toUpperCase(),
            phone: pers.phone,
            salaire: fmt(pers.salaire),
            prime: fmt(pers.prime),
            desc_prime: pers.desc_prime,
            dette: fmt(pers.dette),
            remboursement: fmt(pers.remboursement),
            salaire_net: fmt(pers.salaire_net),
            commentaire: pers.commentaire,
            date: pers.date
        }));

        const doc = new jsPDF({ orientation: "landscape" });
        doc.setFontSize(14);
        doc.text(`Etat de paie du ${mois}/${annee}`, 40, 30);

        autoTable(doc, {
            head: [columns.map(col => col.header)],
            body: data.map(row => columns.map(col => row[col.dataKey])),
            startY: 50,
            styles: { fontSize: 10 },
            headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
            theme: "grid"
        });

        doc.save(`Etat_de_paie_${mois}_${annee}.pdf`);
    };

    return (
        <div className="rappor mt-2">
            <h4 className="text-primary">RAPPORT DE PAIEMENT DE SALAIRE MENSUEL</h4>

            <div className="row my-2 align-items-center justify-content-between">
                <div className="col-lg-6 row">
                    <div className="col-md-4 pe-1">
                        <div className="form-group">
                            <label className="form-label">Années</label>
                            <select className="form-select" defaultValue={annee} onChange={e => setAnnee(e.target.value)}>
                                <option value="">Choisir une année</option>
                                <option value="2024">2024</option>
                                <option value="2025">2025</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4 text-start m-0 p-0">
                        <div className="form-group">
                            <label className="form-label">Mois</label>
                            <div className="input-group">
                                <select className="form-select" defaultValue={mois} onChange={e => setMois(e.target.value)}>
                                    <option value="">Choisir un mois</option>
                                    {listeMois.map(m => {
                                        const index = listeMois.indexOf(m) + 1 < 10 ? `0${listeMois.indexOf(m) + 1}` : listeMois.indexOf(m) + 1;
                                        return <option key={m} value={index}>{m}</option>
                                    })}
                                </select>
                                <button className="btn btn-primary" onClick={handleShowRapport}>
                                    <i className="bx bx-show"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {lesPayes?.length > 0 &&
                    <div className="col-lg-4">
                        <SearchField placeholder='Rechercher un travailleur' plage='liste' conteneur='col-md-3' critere='name' />
                    </div>
                }
            </div>

            <div className="text-end mb-2">
                <button className="btn btn-primary w-auto" onClick={handlePrintSalaire}>
                    <i className="bx bx-printer"></i> PDF
                </button>
            </div>

            {isLoading && <div className="loader"></div>}

            {lesPayes?.length > 0 ?
                <div className="table-responsive mt-2">
                    <table className="table table-striped table-hover table-bordered">
                        <thead className="table-dark">
                            <tr className="align-middle">
                                <th>N°</th>
                                <th>PRENOMS & NOM</th>
                                <th>TELEPHONE</th>
                                <th>SALAIRE</th>
                                <th>PRIME</th>
                                <th>DESC. PRIME</th>
                                <th>DETTE AVANT PAIE</th>
                                <th>DETTE REMBOURSE</th>
                                <th>RECU</th>
                                <th>COMMENTAIRE</th>
                                <th>DATE</th>
                                <th className="text-end">ACTIONS</th>
                            </tr>
                        </thead>

                        <tbody>
                            {lesPayes?.map((pers, ind) => (
                                <tr className="align-middle" key={ind}>
                                    <td>{ind + 1}</td>
                                    <td>{pers.nom?.toUpperCase()}</td>
                                    <td>{pers.phone}</td>
                                    <td>{pers.salaire?.toLocaleString()}</td>
                                    <td>{pers.prime?.toLocaleString()}</td>
                                    <td>{pers.desc_prime}</td>
                                    <td>{pers.dette?.toLocaleString()}</td>
                                    <td>{pers.remboursement?.toLocaleString()}</td>
                                    <td>{pers.salaire_net?.toLocaleString()}</td>
                                    <td>{pers.commentaire}</td>
                                    <td>{pers.date}</td>
                                    <td className="text-end">
                                        <button className="btn btn-danger" title="Imprimer le bulletin"
                                            onClick={() => printbulletin(pers)}>
                                            <i className="bx bx-download"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                :
                <div className="bg-danger-subtle text-danger text-center fs-4 p-3">
                    Aucun travailleur n'a été payé pour le mois choisi !
                </div>
            }
        </div>
    );
};

export default RapportSalaire;
